// extracted by mini-css-extract-plugin
module.exports = {"background":"Header_background__1EWKS"};